module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAzUlEQVR4Ae3XgQbCUBSH8e8VwrK9QRD0bAOgJMQBRADqFZoeaQvbEj3ACS7AkdY5Evf7A7Afts0duZx7JQ0DOnEDDSXYFXTol7sxw+yEOuyMWe8C9Jhp2tQ0LQNxwJ51JHBEUeooYIem1THAgrtBuN3DpUH4AIl4GIQTACuD8AES8bSI94B+vDoaSEQksIkFJPYmS+xjKrEvmsR+KiT2YyfgD2yNy7sBcDAu7waAIP9+qshAizqs/eHxfe7wA9JRYEfFlRGduJELFbmccy/mmnEkylfiUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_exit_to_app_black_24dp.png
// module id = 69
// module chunks = 0